import moment from "moment";
import React, { useState } from "react";
import { Alert, Button, ButtonToolbar, Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";

import genericTranslations from "../../../utils/genericTranslations.js";
import { exportSignalImagesReport } from "../thunks.js";
import "./SignalImagesExport.scss";

const messages = {
  exporting: {
    id: "modules.TrainStopSignalImages.components.SignalImagesExport.exporting",
    description: "Exporting in progress label",
    defaultMessage: "Exporting...",
  },
};

const TODAY = new Date();

const SignalImagesExport = () => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const [selectedDate, setSelectedDate] = useState(null);
  const [isExporting, setIsExporting] = useState(false);
  const [error, setError] = useState(null);

  const canExport = selectedDate !== null;

  const handleExport = async (e) => {
    e.preventDefault();
    setError(null);
    setIsExporting(true);

    try {
      const response = await dispatch(exportSignalImagesReport(selectedDate));

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Seinbeelden overzicht - ${moment(selectedDate).format("DD.MM.YYYY")}.xlsx`;
      link.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      setError(err);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Form onSubmit={handleExport}>
      {error && (
        <Alert variant="danger" onClose={() => setError(null)} dismissible>
          <Alert.Heading>
            {intl.formatMessage(genericTranslations.errorMessage)}
          </Alert.Heading>
          <p>{error.toString()}</p>
        </Alert>
      )}

      <Form.Group controlId="exportDate" className="mt-3 mb-4">
        <Form.Label>{intl.formatMessage(genericTranslations.date)}</Form.Label>
        <DatePicker
          className="form-control"
          wrapperClassName="w-100"
          selected={selectedDate}
          onChange={setSelectedDate}
          dateFormat="dd/MM/yyyy"
          maxDate={TODAY}
        />
      </Form.Group>

      <hr />

      <Form.Group controlId="formActions" className="mb-3">
        <ButtonToolbar>
          <Button
            type="submit"
            variant="primary"
            disabled={!canExport || isExporting}
          >
            {isExporting ? intl.formatMessage(messages.exporting) : "Export"}
          </Button>
        </ButtonToolbar>
      </Form.Group>
    </Form>
  );
};

export default SignalImagesExport;
